import { ApiError } from "@workspace/api-client-react";
import { toast } from "@/hooks/use-toast";

export function isRateLimitError(error: unknown): error is ApiError<{
  error?: string;
  retryAfterSeconds?: number;
}> {
  return error instanceof ApiError && error.status === 429;
}

function getRetrySeconds(err: ApiError<unknown>): number | null {
  const data = err.data as { retryAfterSeconds?: unknown } | null;
  if (data && typeof data.retryAfterSeconds === "number" && data.retryAfterSeconds > 0) {
    return Math.ceil(data.retryAfterSeconds);
  }
  const header = err.headers.get("retry-after");
  if (header) {
    const n = Number(header);
    if (Number.isFinite(n) && n > 0) return Math.ceil(n);
  }
  return null;
}

function getServerMessage(err: ApiError<unknown>): string | null {
  const data = err.data as { error?: unknown } | null;
  if (data && typeof data.error === "string" && data.error.trim() !== "") {
    return data.error.trim();
  }
  return null;
}

export function showRateLimitToast(error: unknown): boolean {
  if (!isRateLimitError(error)) return false;

  const seconds = getRetrySeconds(error);
  const serverMessage = getServerMessage(error);

  const description = seconds
    ? `You're going a bit fast — try again in ${seconds} second${seconds === 1 ? "" : "s"}.`
    : "You're going a bit fast — give it a moment and try again.";

  toast({
    title: serverMessage ?? "Slow down a sec",
    description,
  });

  return true;
}
